import { CdnBaseUrl } from 'components/Utilities/urlUtils'
export const INFO_ICON_URL = `${CdnBaseUrl}/knowledgepoint/InfoCircle.svg`
export const MANUFACTURER_OPTION = 'Manufacturer option'
export const MANUFACTURER_OPTIONS = 'Manufacturer Options'
export const MASTERSPEC_OPTION = 'MasterSpec option'
export const PROPERTY_VALUE = 'Property value'
